module.exports = __webpack_public_path__ + "img/diandong.3b4c2715.png";